import {
  Backdrop,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useCallback } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { VerificationRepository } from "../../repositories/VerificationRepository";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import { set } from "date-fns";
import PdfPreview from "../../common/utils/PdfPreview";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export const ContractVerification = ({}) => {
  const { verificationCode } = useParams();

  const [data, setData] = useState(null);
  const [isDocumentVerified, setIsDocumentVerified] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const loadRecaptchaCode = useCallback(
    async (action) => {
      if (!executeRecaptcha) {
        console.log("Execute recaptcha not yet available");
        return;
      }

      let token = await executeRecaptcha(action);
      return token;
    },
    [executeRecaptcha],
  );

  useEffect(() => {
    if (verificationCode && executeRecaptcha) {
      fetchContractDataByVerificationCode();
    }
  }, [verificationCode, executeRecaptcha]);

  const fetchContractDataByVerificationCode = async () => {
    setLoading(true);
    let recaptchaToken = await loadRecaptchaCode("contract_verification");
    console.log("Recaptcha token:", recaptchaToken);
    VerificationRepository.veirifyContract(verificationCode, recaptchaToken)
      .then((response) => {
        setData(response.data);
        verifyContract(response.data);
      })
      .catch((error) => {
        if (error?.response?.status == 404) {
          setError("Не е пронајден договор со дадениот код за верификација.");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const verifyContract = (contractData) => {
    let valid = true;

    console.log(contractData);

    if (!contractData?.dateSignedByCA) {
      valid = false;
      setError("Договорот не е потпишан од страна на договорниот орган.");
    } else if (!contractData?.dateSignedByEO) {
      valid = false;
      setError("Договорот не е потпишан од страна на економскиот оператор.");
    } else if (!contractData?.isValid) {
      valid = false;
      setError("Договорот е раскинат.");
    } else if (contractData?.isCanceled) {
      valid = false;
      setError("Договорот е поништен.");
    } else if (contractData?.hasAcceptedAppeal) {
      valid = false;
      setError("Договорот има активна жалба.");
    }

    setIsDocumentVerified(valid);
  };

  return (
    <>
      <Container>
        <Paper style={{ padding: "20px", marginTop: "20px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                Верификација на договор {data?.evidentNumber ?? ""}
              </Typography>
            </Grid>
            {!loading && error && (
              <Grid item xs={12}>
                <Alert severity="error">{error}</Alert>
              </Grid>
            )}
            {!loading && !data && (
              <Grid item xs={12}>
                <Alert severity="error">
                  Неуспешна верификација на договорот.
                </Alert>
              </Grid>
            )}
            {!loading && data && (
              <>
                {!error && isDocumentVerified && (
                  <Grid item xs={12}>
                    <Alert severity="success">
                      Договорот е успешно верификуван.
                    </Alert>
                  </Grid>
                )}

                <Grid item md={6} xs={12}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell>Договорен орган</TableCell>
                        <TableCell>{data?.contractAuthorityName}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Економски оператор</TableCell>
                        <TableCell>{data?.economicOperatorName}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Број на набавка</TableCell>
                        <TableCell>{data?.tenderNumber}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Предмет на набавка</TableCell>
                        <TableCell>{data?.tenderName}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Датум на генерирање</TableCell>
                        <TableCell>
                          {data?.dateCreated
                            ? moment(data.dateCreated).format("DD.MM.YYYY")
                            : "/"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Датум на потпишување од ДО</TableCell>
                        <TableCell>
                          {data?.dateSignedByCA
                            ? moment(data.dateSignedByCA).format("DD.MM.YYYY")
                            : "/"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Датум на потпишување од ЕО</TableCell>
                        <TableCell>
                          {data?.dateSignedByEO
                            ? moment(data.dateSignedByEO).format("DD.MM.YYYY")
                            : "/"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Grid>
                <Grid item xs={12} md={6}>
                  {data?.documentBase64 && (
                    <PdfPreview base64Pdf={data?.documentBase64} />
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </Paper>
      </Container>

      {loading && (
        <Backdrop style={{ zIndex: 9999 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
};

export default ContractVerification;
